var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox overflow-box" },
    [
      _c("base-table", {
        ref: "table",
        attrs: {
          loading: _vm.listLoading,
          "table-data": _vm.tableData,
          columns: _vm.tableColumns,
          showPagination: false,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["merchant:product:unit:save"],
                        expression: "['merchant:product:unit:save']",
                      },
                    ],
                    staticClass: "mt20",
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(0)
                      },
                    },
                  },
                  [_vm._v(" 添加单位 ")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "operate",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["merchant:product:unit:update"],
                        expression: "['merchant:product:unit:update']",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(1, row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["merchant:product:unit:delete"],
                        expression: "['merchant:product:unit:delete']",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.handleDelete(row.id)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }